module.exports = __webpack_public_path__ + "static/pattern-b9a67f7ce80332a32cd86c4612e67a92.png";